(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[931],{

/***/ 76899:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_landing_Container__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94964);
/* harmony import */ var _components_landing_Head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81519);
/* harmony import */ var _components_landing_Press__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71723);
/* harmony import */ var _data_press_items_json__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48379);
/* harmony import */ var _data_seo_json__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35546);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);








var PRESS_DATA = _data_press_items_json__WEBPACK_IMPORTED_MODULE_4__.find(function (i) {
  return i.name === "datamynt-mpos";
});

function DataMyntAndroid() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_landing_Head__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
      SEO: _data_seo_json__WEBPACK_IMPORTED_MODULE_5__
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_landing_Container__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_components_landing_Press__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        item: PRESS_DATA,
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("p", {
          className: "font-semibold text-lg",
          children: ["Merchants may now download and use Data Mynt\u2019s Stable Crypto Mobile Point of Sale (mPOS)", " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
            href: "https://play.google.com/store/apps/details?id=com.datamynt",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
              className: "text-primary underline",
              children: "Android App on Google Play Store"
            })
          }), " ", "today to get paid by their customers instantly for higher margins; higher order values; and attracting new customers."]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("p", {
          className: "text-gray-50",
          children: ["Oakland, CA (June 29, 2022) - Data Mynt mPOS, built on Data Mynt\u2019s leading stable cryptocurrency merchant payment and checkout protocol, is now live and available for download on the", " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
            href: "https://play.google.com/store/apps/details?id=com.datamynt",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
              className: "text-primary underline",
              children: "Google Play Store"
            })
          }), ". The easy-to-use app interface allows merchants to accept and settle crypto from any customer wallet, including Cash App, PayPal, and Coinbase, with instant settlement and no traditional crypto volatility; no declines; and no chargebacks."]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
          className: "text-gray-50",
          children: "In addition to using the Data Mynt crypto mPOS app to get paid or as a Cash on Delivery alternative, Data Mynt merchants and partners may also create and send invoices using the mobile app."
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
          className: "flex items-center space-x-8",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("svg", {
              width: "93",
              height: "68",
              viewBox: "0 0 93 68",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("g", {
                opacity: "0.3",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("path", {
                  d: "M35.4316 0L39.7465 8.855C28.3005 13.363 24.6063 22.9233 24.19 27.14C32.29 28.6733 46.923 36.041 40.655 53.245C34.3869 70.449 17.9824 68.0033 10.5637 64.63C5.3782 62.3683 -3.67566 52.624 1.59314 31.74C6.86194 10.856 26.3474 1.87833 35.4316 0Z",
                  fill: "#3D8ECD"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("path", {
                  d: "M86.2577 0L90.5727 8.855C79.1267 13.363 75.4325 22.9233 75.0161 27.14C83.1161 28.6733 97.7492 36.041 91.4811 53.245C85.2131 70.449 68.8086 68.0033 61.3899 64.63C56.2044 62.3683 47.1505 52.624 52.4193 31.74C57.6881 10.856 77.1736 1.87833 86.2577 0Z",
                  fill: "#3D8ECD"
                })]
              })
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            className: "text-gray-50",
            children: "\u201CWith over 85% of merchants seeking to accept crypto as payment, Data Mynt lowers the barrier to entry with enhanced cash management benefits and 24/7 instant settlement and access to revenue. We\u2019re entering a new digital golden era for merchant & commerce payment services,\u201D noted Data Mynt CEO, Alex Christian."
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("p", {
          className: "text-gray-50",
          children: ["Download the new mPOS on the", " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
            href: "https://play.google.com/store/apps/details?id=com.datamynt",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
              className: "text-primary underline",
              children: "Google Play Store"
            })
          }), " ", "here or connect with Data Mynt today to book a", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
            href: "https://datamynt.com/contactus",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
              className: "text-primary underline",
              children: "demo"
            })
          }), "!"]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("h6", {
          className: "text-black text-md",
          children: "About DataMynt"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
          className: "text-gray-50",
          children: "Data Mynt is the leading provider of stable crypto checkout & payment solutions. Its suite of products offers merchants, ecommerce platforms, & partners an omnichannel experience of accepting safe, secure crypto payments free from volatility and the risks and costs of traditional payment methods. The Data Mynt stable crypto checkout payment protocol is designed to streamline implementation via Mobile Point of Sale, API, branded web page, and iFrame, while consistently delivering a seamless customer experience. DataMynt.com"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("ul", {
          className: "flex space-x-4",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("li", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
              target: "_blank",
              href: "https://datamynt.com",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
                className: "text-primary font-semibold",
                children: "Website"
              })
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            children: "|"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("li", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
              target: "_blank",
              href: "https://twitter.com/DataMynt",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
                className: "text-primary font-semibold",
                children: "Twitter"
              })
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            children: "|"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("li", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
              target: "_blank",
              href: "https://www.linkedin.com/company/datamynt/",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
                className: "text-primary font-semibold",
                children: "LinkedIn"
              })
            })
          })]
        })]
      })
    })]
  });
}

/* harmony default export */ __webpack_exports__["default"] = (DataMyntAndroid);

/***/ }),

/***/ 7794:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/press/datamynt-mpos",
      function () {
        return __webpack_require__(76899);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,2013,260,4617,9744,9866,3874,2757,6556,5445,906,7258,5675,2580,6770,646,9530,2834,7965,4964,169,6111,9774,2888,179], function() { return __webpack_exec__(7794); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);